/** 0.34.0 ve önceki agent'ların döndürdüğü /api/... yollarını da onarır. */
export function normalizeAgentOperationStatusPath(rawPath: string): string {
  let path = String(rawPath || '').trim()
  if (!path) return '/'
  if (/^https?:\/\//i.test(path)) {
    try {
      const parsed = new URL(path)
      path = parsed.pathname + parsed.search
    } catch { return '/' }
  }
  while (path.startsWith('/api/api/')) path = path.slice(4)
  if (path.startsWith('/api/')) path = path.slice(4)
  if (!path.startsWith('/')) path = `/${path}`
  return path
}

export function shouldTerminateAgentOperationPolling(status: unknown, failures: number): boolean {
  return failures >= 40 || (Number(status) === 404 && failures >= 5)
}
